<template>
    <div ref="pageBox">
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                     class="unitWidth" size="small">
                <el-form-item :label="$t('Shift.factory')">
                    <el-select v-model="fcCode" :placeholder="$t('base.PleaseSelect')" :clearable="isclear" :disabled="ischeck" filterable @change="fcChange">
                        <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName" :value="factory.fcCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.storeName')">
                    <el-select v-model="strCode" :placeholder="$t('base.PleaseSelect')" clearable filterable @change="houseChange">
                        <el-option v-for="house in houseList" :key="house.spsId" :label="house.strName" :value="house.strCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="searchTable()">{{$t('base.search')}}</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent :title="$t('Account.spareOrder')" ref="LabelContent">
            <div slot="btns">
                <!--<el-button size="small" type="success" @click=";(ifAddText = '0'),updatePartInfo()"> 新增</el-button>-->
                <!--                <el-button size="small" type="success" @click=";(record = true),updateToolingRecord()">领用</el-button>-->
                <!--                <el-button size="small" type="warning" @click=";(record = false),updateToolingRecord()">归还</el-button>-->
                <span v-for="acc in access" :key="acc">
                    <el-button size="small" type="success" @click=";(waring = true),getPurchase()"
                            v-if="acc=='SPAREPRO002'">{{$t('Account.Finish')}}</el-button>
                    <el-button size="small" type="success" @click=";(waring = false),getPurchase()"
                            v-if="acc=='SPAREPRO001'" style="margin-right:10px">{{$t('Account.Purchase')}}</el-button>
                </span>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center" border :cell-style="rowClass"
                      @selection-change="handleSelectionChange" @sort-change="sortChange">
                <el-table-column prop="spCode" :label="$t('Account.spareCode')" width="130"/>
                <el-table-column prop="spName" :label="$t('Account.spareName')" width="120" show-overflow-tooltip/>
                <el-table-column prop="spBrand" :label="$t('Account.spareBrand')" width="120"/>
                <el-table-column prop="spModel" :label="$t('Account.spareModel')" width="120" show-overflow-tooltip/>
                <el-table-column prop="fcName" :label="$t('Shift.factory')" width="180"/>
                <el-table-column prop="spLevel" :label="$t('Account.sort')"/>
                <el-table-column prop="strName" :label="$t('Account.storeName')" width="110"/>
                <el-table-column prop="sppName" :label="$t('Account.locatorName')" width="110"/>
                <el-table-column prop="spStatus.desc" :label="$t('Account.currentState')" width="130"/>
                <el-table-column prop="spSafeStock" sortable :label="$t('Account.safetyStock')" width="120"/>
                <el-table-column prop="spSurplusStock" sortable :label="$t('Account.currentStock')" width="120"/>
                <el-table-column prop="spMaxStock" sortable :label="$t('Account.stockCeil')" width="120"/>
                <el-table-column prop="unit" :label="$t('Account.unit')"/>
                <el-table-column prop="waringTime" :label="$t('Account.waringTime')" width="160"/>
                <el-table-column prop="arrivalTime" :label="$t('Account.arrivalTime')" :formatter="this.transformDateFormat" width="160"/>
                <el-table-column prop="purchaseOrderCode" :label="$t('Account.purchaseOrderCode')" width="140"/>
                <el-table-column prop="supplierCode" :label="$t('Account.supplierCode')" width="120"/>
                <el-table-column prop="supplierName" :label="$t('Account.supplierName')" width="120"/>
                <el-table-column prop="remark" :label="$t('Account.remark')" width="120" show-overflow-tooltip/>
            </el-table>
        </div>
        <el-pagination
            @size-change="paginationChange"
            @current-change="paginationCurrentChange"
            :current-page="searchParams.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchParams.pageCount"
        />
        <el-dialog :title="waring ? $t('Account.Finish') : $t('Account.Purchase')" width="70vw" :visible.sync="purchaseShow" style="text-align:left">
            <div style="color: red;margin-top: -2vw;text-align: center;width: 100%">
                <p>{{$t('Account.spareCode')+'_'+$t('Account.spareName')+'_'+$t('Account.safetyStock')+'_'+$t('Account.currentStock')+'_'+$t('Account.stockCeil')+'。'}}</p>
            </div>
            <el-transfer class="edit_dev"
                style="margin-left: 4.5vw;margin-top:20px"
                filterable
                :titles="[$t('Account.unselected'), $t('Account.selected')]"
                :filter-method="filterMethod"
                :filter-placeholder="$t('Account.enter')"
                v-model="sparePartValue"
                :data="sparePartData">
            </el-transfer>
            <el-form style="margin-top: 3vw;margin-left: 18vw;" :model="purchaseWaring" :rules="purchase" ref="purchase"
                     label-width="150px" class="demo-roleForm" v-if="!waring">
                <el-form-item :label="$t('Account.purchaseOrderCode')" prop="purchaseOrderCode">
                    <el-input v-model="purchaseWaring.purchaseOrderCode"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.arrivalTime')" prop="arrivalTime">
                    <el-date-picker
                        :picker-options="pickerOptions"
                        v-model="purchaseWaring.arrivalTime"
                        type="date"
                        :placeholder="$t('base.PleaseSelect')"
                        @focus="donnes">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('Account.remark')">
                    <el-input type="textarea" v-model="purchaseWaring.remark" :placeholder="$t('Account.specify')"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="purchaseShow = false">{{$t('base.cancel')}}</el-button>
                <el-button type="primary"
                           @click="purchaseCommit(waring ? '' : 'purchase')">{{ waring ? $t('Account.Finish') : $t('Account.Purchase') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { sparePartWaringList } from '../../../libs/api'
    import moment from 'moment'

    export default {
        name: 'SpareProcurement',
        data() {
            return {
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                tableData: [],
                factoryList: [],
                houseList: [],
                partWaringList: [],
                waring: false,
                purchaseShow: false,
                sparePartData: [],
                sparePartValue: [],
                filterMethod(query, item) {
                    return item.pinyin.indexOf(query) > -1
                },
                pickerOptions: {
                    if(time) {
                        return time.getTime() < Date.now() - 8.64e7
                    }
                },
                purchaseWaring: {
                    spwIds: '',
                    purchaseOrderCode: '',
                    arrivalTime: '',
                    remark: ''
                },
                purchase: {
                    purchaseOrderCode: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ],
                    arrivalTime: [
                        {
                            required: true,
                            message: this.$t('base.PleaseSelect'),
                            trigger: 'blur'
                        }
                    ]
                },
                spPartStatus: '',
                userInfo: {},
                role: {},
                ischeck: true,
                isclear: false,
                access: [],
                fcCode: '',
                strCode: ''
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0;i < role.length;i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getAllFactory()
            },
            rowClass(row, index) {
                if (row.row.spStatus.code == 'a_insufficient') {
                    return {
                        'background-color': '#ee5253',
                        'color': '#fff'
                    }
                }
                if (row.row.spStatus.code == 'b_purchase') {
                    return {
                        'background-color': '#f1c40f',
                        'color': '#fff'
                    }
                }
            },
            generateData() {
                const data = []
                const cities = this.partWaringList
                const pinyin = []
                for (let i = 0; i < this.partWaringList.length; i++) {
                    pinyin.push(this.partWaringList[i].spCode)
                }
                cities.forEach((city, index) => {
                    data.push({
                        label: city.spCode + '_' + city.spName + '_' + city.spSafeStock + '_' + city.spSurplusStock + '_' + city.spMaxStock,
                        key: index,
                        pinyin: pinyin[index],
                        value: city.spCode
                    })
                })
                return data
            },
            //分页
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            fcChange () {
                this.strCode = ''
                this.partStoreHouseList()
                this.searchTable()
            },
            houseChange() {
                this.searchTable()
            },
            getPurchase() {
                if (this.fcCode == undefined || this.fcCode == '') {
                    this.$message.error(this.$t('mechanism.selectFc'))
                    return
                }
                if (this.strCode == undefined || this.strCode == '') {
                    this.$message.error(this.$t('Account.selectCk'))
                    return
                }
                this.purchaseShow = true
                //true 是完成,false 是采购
                this.waring ? this.spPartStatus = 'b_purchase' : this.spPartStatus = 'a_insufficient'
                this.purchaseWaring = {}
                this.sparePartWaringList()
            },
            /*handleChange(value, direction, movedKeys) {
                console.log('value',value);
                console.log('direction',direction);
                console.log('movedKeys',movedKeys);
            },*/
            donnes() {
                var arrTime = []
                for (let i = 0; i < 1; i++) {
                    var tempDate = new Date() // 获取今天的日期
                    tempDate.setDate(tempDate.getDate() + i) // 今天的前N天的日期，N自定义
                    arrTime.push(moment(tempDate).format('YYYY-MM-DD'))
                }
                this.pickerOptions = {
                    disabledDate(time) {
                        for (let i = 0; i < arrTime.length; i++) {
                            let date = new Date(arrTime[i])
                            const day = new Date(new Date(date.toLocaleDateString()).getTime() + 1000 * 60 * 60 * 24)
                            if (time.getTime() === day.getTime() - 24 * 60 * 60 * 1000) {
                                return true
                            }
                        }
                        if (time) {
                            return time.getTime() < Date.now() - 8.64e7
                        }
                    }
                }
            },
            purchaseCommit(purchase) {
                if (this.sparePartValue.length == 0) {
                    this.$message.error(this.$t('base.PleaseSelect'))
                    return
                }
                if (purchase == undefined || purchase == '') {
                    this.handlePurchase()
                    return
                }
                this.$refs[purchase].validate((valid) => {
                    if (valid) {
                        this.handlePurchase()
                    } else {
                        return false
                    }
                })
            },
            handlePurchase() {
                var spCodeArr = []
                for (let i = 0; i < this.sparePartData.length; i++) {
                    for (let j = 0; j < this.sparePartValue.length; j++) {
                        if (this.sparePartData[i].key == this.sparePartValue[j]) {
                            spCodeArr.push(this.sparePartData[i].value)
                        }
                    }
                }
                var str = ''
                for (let z = 0; z < this.partWaringList.length; z++) {
                    for (let k = 0; k < spCodeArr.length; k++) {
                        if (this.partWaringList[z].spCode == spCodeArr[k]) {
                            if (this.waring) {
                                str += this.partWaringList[z].spwId + ','
                            } else {
                                str += this.partWaringList[z].spwId + ','
                            }
                        }
                    }
                }
                str = str.substring(0, str.length - 1)
                if (this.waring) {
                    this.sparePartWaringPurchaseComplete(str)
                } else {
                    this.purchaseWaring.spwIds = str
                    this.purchaseWaring.arrivalTime = moment(this.purchaseWaring.arrivalTime).format('YYYY-MM-DD')
                    this.sparePartWaringPurchase()
                }
            },
            /*采购*/
            sparePartWaringPurchase() {
                let options = {
                    method: 'POST',
                    url: this.$api.sparePartWaringPurchase,
                    params: this.purchaseWaring
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.searchTable()
                        this.purchaseShow = false
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            /*采购完成*/
            sparePartWaringPurchaseComplete(str) {
                let queryParams = {
                    spwIds: str
                }
                let options = {
                    method: 'POST',
                    url: this.$api.sparePartWaringPurchaseComplete,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.searchTable()
                        this.purchaseShow = false
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            sparePartWaringList() {
                this.sparePartData = []
                let params = {}
                if(this.spPartStatus != undefined && this.spPartStatus != ''){
                    params['spStatus'] = this.spPartStatus
                }
                if (this.fcCode != undefined && this.fcCode != ''){
                    params['fcCode'] = this.fcCode
                }
                if (this.strCode != undefined && this.strCode != ''){
                    params['strCode'] = this.strCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.sparePartWaringList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if(response.data != undefined && response.data != '') {
                            this.sparePartValue = []
                            this.partWaringList = response.data
                            this.sparePartData = this.generateData()
                        }else{
                            this.sparePartValue = []
                            this.partWaringList = []
                            this.sparePartData = []
                        }
                    }
                })
            },
            partStoreHouseList () {
                let params = {}
                if (this.fcCode != undefined && this.fcCode != '') {
                    params['fcCode'] = this.fcCode
                } else {
                    return
                }
                let options = {
                    method: 'get',
                    url: this.$api.partStoreHouseList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.houseList = []
                        if (response.data != undefined && response.data != '') {
                            this.houseList = response.data
                        }
                    }
                })
            },
            searchTable() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                if (this.fcCode != undefined && this.fcCode != ''){
                    queryParams['fcCode'] = this.fcCode
                }
                if (this.strCode != undefined && this.strCode != ''){
                    queryParams['strCode'] = this.strCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.getAllSparePartWaring,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            getAllFactory () {
                let options = {
                    method: 'get',
                    url: this.$api.getAllFactory
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryList = []
                        var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                        var aa = response.data
                        if (this.ischeck) {
                            for (var i = 0;i < aa.length;i++) {
                                for (let j = 0;j < userInfo.roles.length;j++) {
                                    if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                                        this.factoryList.push(aa[i])
                                        this.fcCode = this.userInfo.fcCode
                                    }
                                }
                            }
                        } else {
                            this.factoryList = response.data
                        }
                    }
                    this.searchTable()
                    this.partStoreHouseList()
                })
            }
        }
    }
</script>

<style scoped>
    .edit_dev >>> .el-transfer-panel {
        width:350px;
    }
</style>
